import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import Table from '../../../../common/Table';
import {
  DEFAULT_PAGE_SIZE,
  FOOD_PUBLIC_TYPE,
  ITINERARY_FOOD_INVOICE_BILLING_STATUS,
} from '../../../../../config/constants';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import itinerarySupplierFoodPropTypes from '../proptypes/ItinerarySupplierFoodProptypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import EnumStatus from '../../../../common/EnumStatus';

const getDefaultPageSize = (list = []) =>
  list.length > 10 ? DEFAULT_PAGE_SIZE : list.length;

const ItinerarySupplierFoodBasicInformationResource = ({
  id,
  supplier,
  originLocationName,
  destinationLocationName,
  cabinCrew,
  registeredBus,
  itinerarySupplierFoodDetailList,
  driverList,
  cabinCrewList,
  passengerFlow,
  createDate,
  comment,
}) => {
  const supplierBusiness = supplier && supplier.business;

  const passengerFlowForLocationList =
    passengerFlow && passengerFlow.passengerFlowForLocationList
      ? passengerFlow.passengerFlowForLocationList
      : [];

  return (
    <>
      <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>

      <ResourceProperty label="Proveedor:">
        {supplierBusiness && supplierBusiness.name
          ? supplierBusiness.name
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="RUC:">
        {supplierBusiness && supplierBusiness.businessTaxId
          ? supplierBusiness.businessTaxId
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Origen:">
        {originLocationName || '-'}
      </ResourceProperty>

      <ResourceProperty label="Destino:">
        {destinationLocationName || '-'}
      </ResourceProperty>

      <ResourceProperty label="Bus:">
        {registeredBus && registeredBus.companyBusId
          ? registeredBus.companyBusId
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Tripulante registrado:">
        {cabinCrew && cabinCrew.cabinCrewName ? cabinCrew.cabinCrewName : '-'}
      </ResourceProperty>

      <ResourceProperty label="DNI tripulante:">
        {cabinCrew && cabinCrew.cabinCrewIdDocumentNumber
          ? cabinCrew.cabinCrewIdDocumentNumber
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Fecha de creación:">
        {tzNormalizeDate({ date: createDate, format: DATE_TIME_FORMAT }) || '-'}
      </ResourceProperty>

      <ResourceProperty label="Comentarios:">{comment || '-'}</ResourceProperty>

      <h3>Detalle de alimentación</h3>

      {itinerarySupplierFoodDetailList &&
      itinerarySupplierFoodDetailList.length > 0 ? (
        <Table
          columns={[
            {
              Header: 'Alimentación',
              accessor: 'food.name',
              className: 'text-center',
            },
            {
              Header: 'Tipo público',
              accessor: 'publicType',
              className: 'text-center',
              Cell: (row) => (
                <EnumStatus
                  enumObject={FOOD_PUBLIC_TYPE}
                  enumValue={row.value}
                />
              ),
            },
            {
              Header: 'Cantidad',
              accessor: 'quantity',
              className: 'text-center',
            },
            {
              Header: 'Costo',
              accessor: 'cost',
              className: 'text-center',
            },

            {
              Header: 'Estado de facturación',
              accessor: 'billingStatus',
              className: 'text-center',
              Cell: (row) => (
                <EnumStatus
                  enumObject={ITINERARY_FOOD_INVOICE_BILLING_STATUS}
                  enumValue={row.value}
                />
              ),
            },
          ]}
          data={itinerarySupplierFoodDetailList}
          manual={false}
          defaultFilterMethod={filterMethodCaseInsensitive}
          defaultPageSize={getDefaultPageSize(itinerarySupplierFoodDetailList)}
          showPagination={itinerarySupplierFoodDetailList.length > 10}
        />
      ) : (
        <div className="alert alert-info">Sin detalle de alimentación</div>
      )}

      <h3>Conductores</h3>

      {driverList && driverList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Nombre',
                accessor: 'driverName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'driverIdDocumentNumber',
                className: 'text-center',
              },
            ]}
            data={driverList}
            defaultPageSize={driverList.length}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin conductores</div>
      )}

      <h3>Servicio a bordo</h3>

      {cabinCrewList && cabinCrewList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Nombre',
                accessor: 'cabinCrewName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'cabinCrewIdDocumentNumber',
                className: 'text-center',
              },
            ]}
            data={cabinCrewList}
            defaultPageSize={cabinCrewList.length}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin Servicio a bordo</div>
      )}

      <h3>Flujo de pasajeros</h3>

      {passengerFlowForLocationList.length > 0 ? (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Parada Autorizada',
                accessor: 'locationName',
                className: 'text-center',
              },
              {
                Header: 'Embarques',
                accessor: 'boardingPassengers',
                className: 'text-center',
              },
              {
                Header: 'Desembarques',
                accessor: 'leavingPassengers',
                className: 'text-center',
              },
            ]}
            data={passengerFlowForLocationList}
            defaultPageSize={passengerFlowForLocationList.length}
            showPagination={false}
          />
        </div>
      ) : (
        <div className="alert alert-info">Sin flujo</div>
      )}
    </>
  );
};

ItinerarySupplierFoodBasicInformationResource.propTypes =
  itinerarySupplierFoodPropTypes;

ItinerarySupplierFoodBasicInformationResource.defaultProps = {
  itinerarySupplierFoodDetailList: [],
  driverList: [],
  cabinCrewList: [],
  passengerFlow: null,
  cabinCrew: null,
  supplier: null,
  registeredBus: null,
  createDate: null,
};

export default ItinerarySupplierFoodBasicInformationResource;
